const siteConfig = {
  brandName: "Napandstone",
  logoText: "NAPANDSTONE",
  tagline: "Everyday form, made to last",
  description:
    "Organic denim made to be worn hard, repaired often, and kept for years.",
  currency: "USD",
  locale: "en-US",
  operatingRegion: "Hong Kong",
  countryCode: "HK",
  timeZone: "Asia/Hong_Kong",
  shippingFee: 9.99,
  dispatchEstimate: "1–2 business days",
  deliveryEstimate: "3–6 business days after dispatch",
  returnWindowDays: 30,
  contact: {
    email: "shop@napandstone.art",
    address: null,
    returnAddress: null,
  },
  storage: {
    cart: "cartItems",
    wishlist: "wishlist",
    pendingOrder: "napandstonePendingOrder",
  },
  shippingCountries: [
    "Australia", "Austria", "Belgium", "Canada", "Denmark", "Finland",
    "France", "Germany", "Hong Kong", "Ireland", "Italy", "Japan",
    "Malaysia", "Netherlands", "New Zealand", "Norway", "Portugal",
    "Singapore", "South Korea", "Spain", "Sweden", "Switzerland",
    "Thailand", "United Kingdom", "United States",
  ],
  policies: {
    lastUpdated: "October 21, 2026",
  },
  navigation: [
    { label: "Shop", to: "/shop" },
    { label: "Men", to: "/shop?gender=Men" },
    { label: "Women", to: "/shop?gender=Women" },
    { label: "Jeans", to: "/shop?category=Jeans" },
    { label: "About", to: "/about" },
  ],
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);

export default siteConfig;
